import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IOrderRelation } from '../interfaces/IOrderRelation';
import { IKnmOrder } from '../../KnmModule/interfaces/IKnmOrder';

export async function fetchOrdersRelationDictionaries(
  orderId: string,
  orderVersionId: string,
): Promise<IOrderRelation> {
  const queryParams = new URLSearchParams();

  queryParams.append('orderId', orderId);
  queryParams.append('orderVersionId', orderVersionId);

  return apiGet(`${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/catalogs/orders/relation-dictionaries?${queryParams}`);
}

export async function fetchOrdersAll(): Promise<IKnmOrder[]> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.LK_SERVICE, false)}/catalogs/orders/all`);
}
